import {
  SimpleSavingsOptions,
  SavingsResponse,
  SolarSavingsOptions,
} from "@givenergy/sales-simple-energy-comparison";
import { ServiceBase } from "@services/service-base.ts";

export class ElectricitySavingsService extends ServiceBase {
  async getSimpleSavings(userId: string, options: SimpleSavingsOptions) {
    const simpleSavingsUrl = new URL("simple-savings", this.apiUrl);

    const request = await fetch(simpleSavingsUrl, {
      method: "POST",
      headers: {
        "givenergy-userid": userId,
      },
      body: JSON.stringify(options),
    });

    if (!request.ok) {
      throw new Error("Unable to calculate simple savings");
    }

    const response = await request.json();
    return response as SavingsResponse;
  }

  async getSolarSavings(userId: string, options: SolarSavingsOptions) {
    const solarSavingsUrl = new URL("solar-savings", this.apiUrl);

    const request = await fetch(solarSavingsUrl, {
      method: "POST",
      headers: {
        "givenergy-userid": userId,
      },
      body: JSON.stringify(options),
    });

    if (!request.ok) {
      throw new Error("Unable to calculate solar savings");
    }

    const response = await request.json();
    return response as SavingsResponse;
  }
}
